(function () {
  'use strict';

  class VehicleEditCtrl {
    constructor($scope, Authenticator, safetyService) {
      this.scope = $scope;
      this.safetyService = safetyService;
      this.authenticator = Authenticator;
    }

    handleEditVehicleButtonClick(veiculo, idioma) {
      this.loadReactComponent({
        onEditSuccess: () => {
          this.scope.$apply(() => this.scope.$emit('vehicleEdited'));
          this.safetyService.unmountReactComponent('editVehicleDiv');
        },
        onClose: () => {
          this.safetyService.unmountReactComponent('editVehicleDiv');
        },
        vehicle: veiculo,
        idioma
      });
    }

    loadReactComponent(props = {}) {
      const appName = 'safetyApp',
          componentPath = './VehicleEditModal',
          componentId = 'editVehicleDiv';
      return this.safetyService.initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentPath, componentId, props));
    }
  }

  angular
    .module('safetyModule')
    .controller('VehicleEditCtrl', VehicleEditCtrl);
}());
